import styles from "./Statement.module.css";

export function Statement() {
  return (
    <section className={styles.section} aria-label="Brand statement">
      <div className={`container ${styles.inner}`}>
        <div className={styles.row}>
          <div className={styles.left}>
            <p className={styles.kicker}>The philosophy</p>
          </div>
          <div className={styles.right} data-reveal>
            <p className={styles.quote}>
              Hair that feels <em>considered</em>, never overdone. Color with dimension,
              <br />
              shape that holds, and a finish built for <em>how you actually live.</em>
            </p>
            <p className={styles.body}>
              Every appointment is one client at a time, with the time built in to listen, plan,
              and finish properly. Results that still look right in week six.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}